import { useEffect, useId, useState } from "react";
import type { AuthedApi } from "../api/Api";

// AuthedApi のオンライン状態を購読し、変化に応じて再描画する。
// 整数IDマスタの編集系 UI を !isOnline で無効化する用途。
// api.isOnline は同期 boolean だが state 変化を React に伝えるため subscribeOnlineState を使う。
export function useIsOnline(api: AuthedApi): boolean {
  const reactId = useId();
  const [isOnline, setIsOnline] = useState<boolean>(api.isOnline);
  useEffect(() => {
    const unsubscribe = api.subscribeOnlineState(reactId, () => setIsOnline(api.isOnline));
    setIsOnline(api.isOnline);
    return unsubscribe;
  }, [api, reactId]);
  return isOnline;
}
